import { findDuplicates } from "../../utils";

const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
const IP_ADDRESS_REGEXP = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; // eslint-disable-line
const PASSWORD_REGEXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&`]).{8,}$/;
const PROXY_TYPE_REGEXP = /^[A-Z0-9_]+$/;

const PASSWORD_ERROR_MESSAGE = `Password should pass next requirements: Minimum eight characters, at least one
  uppercase letter, one lowercase letter, one number and one special character
`;
const PROXY_TYPE_ERROR_MESSAGE = "There is invalid tag name, allowed only capital symbols, numbers and sign \"_\"";

const isValidHttpUrl = (string) => {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
};
export const urlValidation = value => value && !isValidHttpUrl(value) ? "Invalid URL" : undefined;

export const createRequiredValidator = () => (value) => value ? undefined : "This field is required.";

export const validateEmail = (value) => (EMAIL_REGEXP.test(value || "") ? undefined : "Please make sure that email is correct");

export const validatePassword = (value) => (PASSWORD_REGEXP.test(value || "") ? undefined : PASSWORD_ERROR_MESSAGE);

export const validateProxyType = (value) => (PROXY_TYPE_REGEXP.test(value || "") ? undefined : PROXY_TYPE_ERROR_MESSAGE);

export const composeValidators = (...validators) => (value, allValues) => {
    let error;

    validators.some((validator) => {
        error = validator(value, allValues);

        return error;
    });

    return error;
};

export const validateIpAddress = (value) => (
    (IP_ADDRESS_REGEXP.test(String(value) || "") ? undefined : "You have entered an invalid IP address!")
);

export const minValueValidator = (label, min) => (value) => (
    (value || 0) >= min ? undefined : `${label || "Value"} should be greater or equal than ${min}`
);

export const minValueValidatorOmitEmpty = (label, min) => (value) => {
    return (((value || 0) >= min) || ((value || 0) === 0)) ? undefined : `${label || "Value"} should be greater or equal than ${min}`
}

export const maxValueValidator = (label, max) => (value) => (
    (value || 0) <= max ? undefined : `${label || "Value"} should be less or equal than ${max}`
);

export const createMinLengthValidator = (label, minLength) => (value) => (
    (String(value) || "").length >= minLength ? undefined : `${label || "Value"} length should be greater or equal than ${minLength}`
);

export const createMaxLengthValidator = (label, maxLength) => (value) => (
    (String(value) || "").length <= maxLength ? undefined : `${label || "Value"} length should be less or equal than ${maxLength}`
);

export const moreThenZeroValidator = (label) => (value) => (
    value > 0 ? undefined : `${label || "Value"} length should be more than 0`
);

export const moreThenZeroSelectedValidator = (label) => (value) => (
    (value && value.length) > 0 ? undefined : `${label || "Value"} should be more than 0 selected`
);

export const validateDuplicateInUrlArea = (value, name = "urls") => {
    if(!value) {
        return;
    }

    const items = value?.split("\n").filter((item) => item !== "");

    return items && findDuplicates(items).length ? `There are duplicated ${name}` : undefined;
};
